export default __webpack_public_path__ + "static/media/menu.5062cf20.svg";